<template>
  <AppHeaderDropdown right no-caret>
    <template slot="header">
      <!--
      <img
        src="img/avatars/6.jpg"
        class="img-avatar"
        alt="admin@bootstrapmaster.com" />
      -->
      <span class="fa-stack fa-lg">
        <i class="fa fa-circle-thin fa-stack-2x"></i>
        <i class="fa fa-user fa-stack-1x"></i>
      </span>
    </template>\
    <template slot="dropdown">
      <b-dropdown-header
        tag="div"
        class="text-center">
        <strong>Settings</strong>
      </b-dropdown-header>
      <b-dropdown-item href="#/profile"><i class="fa fa-user" /> Profile</b-dropdown-item>
      <!--<b-dropdown-item><i class="fa fa-wrench" /> Settings</b-dropdown-item>-->
      <b-dropdown-item href="#/subscription"><i class="fa fa-usd" /> Subscription</b-dropdown-item>
      <b-dropdown-divider />
      <b-dropdown-item href="#/signout"><i class="fa fa-lock" /> Sign Out</b-dropdown-item>
    </template>
  </AppHeaderDropdown>
</template>

<script>
import { HeaderDropdown as AppHeaderDropdown } from '@coreui/vue'
export default {
  name: 'DefaultHeaderDropdownAccnt',
  components: {
    AppHeaderDropdown
  },
  data: () => {
    return { itemsCount: 1 }
  }
}
</script>
